var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 22.1875V30.0625C28.5 36.625 25.875 39.25 19.3125 39.25H11.4375C4.875 39.25 2.25 36.625 2.25 30.0625V22.1875C2.25 15.625 4.875 13 11.4375 13H19.3125C25.875 13 28.5 15.625 28.5 22.1875Z",
    stroke: "#F57E2A",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 10.9375V18.8125C39.75 25.375 37.125 28 30.5625 28H28.5V22.1875C28.5 15.625 25.875 13 19.3125 13H13.5V10.9375C13.5 4.375 16.125 1.75 22.6875 1.75H30.5625C37.125 1.75 39.75 4.375 39.75 10.9375Z",
    stroke: "#F57E2A",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.1778c281e374a17e134cf00dee574b1e.svg";
export { ForwardRef as ReactComponent };